// React
import React from 'react';
// Internal
import CustomTable from 'components/shared/molecules/CustomTable/CustomTable';
import ProductModal from 'components/shared/organisms/ProductModal/ProductModal';
import { clearEngraving } from 'stores/actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
// Styles
import './styles.scss';
// Models
import Product from 'models/Product';
// Services
import ProductService from 'services/product';
// Constants
import Pagination from 'components/shared/molecules/Pagination/PaginationSearch';

class ProductList extends React.Component {
    constructor(props) {
        super(props);
        const page = new URLSearchParams(window.location.search).get('page');
        this.state = {
            productList: [],
            currentProduct: null,
            productModalEnabled: false,
            currentPage: page,
            itemsPerPage: 10,
            lastPage: 1,
        };
        this.headers = Object.freeze([
            {
                name: 'option',
                id: 'name',
            },
            {
                name: 'category',
                id: 'category',
            },
            {
                name: 'action',
                id: 'action',
            },
        ]);
        this.getProductList(this.props.search, this.props.filter);
    }

    componentDidUpdate(prevProps) {
        // Only when the value changes the status update will be triggered
        if (
            prevProps.search !== this.props.search ||
            prevProps.filter !== this.props.filter
        ) {
            this.getProductList(this.props.search, this.props.filter);
        }
    }

    componentWillUnmount() {
        // Remove the product filter from local storage before unmounting
        localStorage.removeItem('product-filter');

        // Remove the product search from local storage before unmounting
        localStorage.removeItem('product-search');
    }

    getFormattedData() {
        return this.state.productList.map((product) => {
            return {
                name: product.name,
                category: product.getCategory(),
                action: (
                    <span
                        className={`text-clickable ${product.id}`}
                        onClick={() => this.viewProductDetails(product)}
                    >
                        Details
                    </span>
                )
            };
        });
    }

    async getProductList(search, filter = 'all') {
        let category = [];

        // Pass the filter options if the selected filter is 'all', otherwise just pass the selected filter as itself
        if (filter === 'all') {
            category = this.props.filterOptions.filter(filterOption => filterOption.value !== 'all').map(filterOption => filterOption.value);
        } else {
            category.push(filter);
        }

        // Add ms before making the API call for the url to render
        await new Promise(resolve => setTimeout(resolve, 100));
  
        const params = {
            category,
            search,
            page: new URLSearchParams(window.location.search).get('page'),
            page_size: this.state.itemsPerPage
        };
        // eslint-disable-next-line no-await-in-loop
        const response = await ProductService.getProducts(params);
        const productList = response.data.data.map((product) => Product(product));
        this.setState({
            productList,
            currentPage: response.data.current_page,
            lastPage: response.data.last_page
        });
    }

    viewProductDetails(product) {
        this.setState({ productModalEnabled: true, currentProduct: product });
    }

    hideProductDetails = () => {
        this.props.clearEngraving();
        this.setState({ productModalEnabled: false, currentProduct: null });
    }

    render() {
        return (
            <div className={`product-list-container ${this.props.className ? this.props.className : ''}`}>
                {
                    this.state.productList.length
                        ? (
                            <div>
                                <CustomTable
                                    data={this.getFormattedData()}
                                    headers={this.headers}
                                    className="dashboard-table"
                                    defaultSortBy={
                                        {
                                            id: 'name',
                                            desc: false,
                                        }
                                    }
                                />
                                <div className="product-paginator">
                                    <Pagination activePage={this.state.currentPage} lastPage={this.state.lastPage} />
                                </div>
                            </div>
                        ) : <p className="mt-4 text-center">No product available.</p>
                }
                <ProductModal
                    show={this.state.productModalEnabled}
                    onHide={this.hideProductDetails}
                    product={this.state.currentProduct}
                />
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        clearEngraving: (engravingObj) => dispatch(clearEngraving(engravingObj))
    };
};

export default connect(null, mapDispatchToProps)(withRouter(ProductList));